<!--This file is part of sisdai-proyecto-base.-->

<!--sisdai-proyecto-base is free software: you can redistribute it and/or modify-->
<!--it under the terms of the GNU Lesser General Public License as published by the-->
<!--Free Software Foundation, either version 3 of the License, or-->
<!--(at your option) any later version.-->

<!--sisdai-proyecto-base is distributed in the hope that it will be useful,-->
<!--but WITHOUT ANY WARRANTY; without even the implied warranty of-->
<!--MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General-->
<!--Public License for more details.-->

<!--You should have received a copy of the GNU Lesser General Public License along-->
<!--with sisdai-proyecto-base. If not, see <https://www.gnu.org/licenses/>.-->

<script setup>
import store from '@/store'
import { onMounted, watch, ref, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
const ruta = useRoute()
const router = useRouter()
import NavegacionPrincipalBase from './components/navegacion/NavegacionPrincipalBase.vue'

const infoDespliegue = {
  version_proyecto: process.env.PACKAGE_VERSION,
  actualizacion_proyecto: process.env.DATE_DEPLOY,
  entorno_proyecto: process.env.ENV_DEPLOY,
}
const entradaInicial = ref(true)

// Agrega aria-hidden al elemento con icono
onMounted(async () => {
  await router.onReady(() => {
    ruta.path === '/' ? (entradaInicial.value = false) : null
  })
})

// Con este watch definimos a donde se moverá el focus al cambiar de ruta
watch(
  () => ruta.path,
  () => {
    if (!entradaInicial.value) {
      if (ruta.path) {
        nextTick(() => {
          moviendoFocoNavegacion(ruta.path)
        })
      }
    } else {
      entradaInicial.value = false
    }
  }
)

function moviendoFocoNavegacion(path) {
  path
  //let carpetas = path.split('/').filter(d => d != '')
  const elemento_receptor = document.querySelector('#principal')
  if (elemento_receptor) {
    elemento_receptor.tabIndex = '-1'
    elemento_receptor.focus()
  }
}
</script>

<template>
  <div
    id="app"
    :class="store.getters['accesibilidad/clasesAccesibles']"
  >
    <a
      href="#principal"
      class="ir-contenido-principal"
      >Ir a contenido principal</a
    >
    <SisdaiNavegacionGobMx />
    <NavegacionPrincipalBase />

    <router-view />

    <!--    El menú de accesibilidad se encuentra en desarrollo, por lo que se comenta-->
    <!--    aquí para su liberación cuando sea funcional-->
    <!--    <SisdaiMenuAccesibilidad :objetoStore="store" />-->

    <SisdaiInfoDeDespliegue
      :versionProyecto="infoDespliegue.version_proyecto"
      :entornoProyecto="infoDespliegue.entorno_proyecto"
      :actualizacionProyecto="infoDespliegue.actualizacion_proyecto"
    />
    <SisdaiPiePaginaConahcyt />
    <SisdaiPiePaginaGobMx />
  </div>
</template>

<style lang="scss">
// Estilos de la biblioteca
@import 'sisdai-css/src/_variables.scss';
@import 'sisdai-css/src/_mixins.scss';

$gap: 30px;

$margin-variations: 5;

$width: (
  'max-main': 1400px,
  'max-view': 1024px,
  'max-text': 700px,
);

$media-queries-limit: (
  'mobile': 769px,
  'tablet': 1025px,
  'navegacion': 1025px,
);

$media-queries-since: (
  'sm': 0,
  'md': 769px,
  'lg': 1025px,
);

.cover {
  background: #223;
  background-size: cover;
  background-position: center;
  color: #fff;
  height: 100vh;
  height: calc(100 * var(--vh) - 50px);
  width: 100%;
  text-align: center;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  top: -50px;
}
.cover-gradient {
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  box-sizing: border-box;
  padding: $gap * 3 $gap * 0.5;
  flex: 1;
  position: relative;
  z-index: 2;
  .cover-logos {
    margin-top: 200px;
    @media (min-width: map-get($media-queries-limit, 'mobile')) {
      width: 400px;
    }
  }
  .cover-title {
    margin: 10px auto;
    font-size: 36px;
    line-height: 38px;
    color: #fff;
    font-weight: bold;
    @media (max-width: calc(map-get($media-queries-limit, 'mobile') - 1px)) {
      &.cover-title-large {
        font-size: 30px;
        line-height: 34px;
      }
    }
    @media (min-width: map-get($media-queries-limit, 'mobile')) {
      max-width: 700px;
      font-size: 52px;
      line-height: 60px;
    }
  }
  .cover-subtitle {
    color: #fff;
    text-align: center;
    max-width: 450px;
    margin: 10px auto;
    font-size: 16px;
    font-weight: 400;
    @media (min-width: map-get($media-queries-limit, 'mobile')) {
      font-size: 21px;
      max-width: 500px;
    }
    a {
      color: #fff;
      font-size: 16px;
      @media (min-width: map-get($media-queries-limit, 'mobile')) {
        font-size: 21px;
      }
      &:hover {
        background: none;
      }
    }
  }
}

.overflow-hidden {
  overflow: hidden;
}

.contenedor-referencias-bibliograficas .lista-referencias {
  overflow-wrap: anywhere;
  margin-top: 0;
  max-height: 400px;
  overflow-y: auto;
}

.contenedor-referencias-bibliograficas .encabezado {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #000;
}

.contenedor-referencias-bibliograficas .lista-referencias li {
  font-size: 14px;
  margin: 0 8px;
  padding: 8px 0;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
